import { render, staticRenderFns } from "./unitOwnershipTransferList.vue?vue&type=template&id=dca2ef4e&"
import script from "./unitOwnershipTransferList.vue?vue&type=script&lang=js&"
export * from "./unitOwnershipTransferList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports